
import DeleteFundingRoundModal from "@/components/modals/forms/DeleteFundingRoundModal.vue";
import { defineComponent, ref, computed, onMounted } from "vue";
import { mainFormatter } from "@/utils/index";
import moment from "moment";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";
import InvestmentHistory from "@/components/widgets/lists/Widget5.vue";

export default defineComponent({
  name: "funding-rounds",
  props: {
    widgetClasses: String,
  },
  components: {
    DeleteFundingRoundModal,
    InvestmentHistory,
  },
  setup(props) {
    const currencyCodeSymbolEnums = {
      dollar: "$",
      pound: "£",
      euro: "€",
    };
    const route = useRoute();
    const store = useStore();
    const rounds = ref<Array<Record<string, unknown>>>([]);
    const businessId = ref<string>(route.params.id as string);
    const refresh = async () => {
      try {
        const response = await store.dispatch(
          Actions.GET_FUNDING_ROUNDS,
          businessId.value
        );
        if (response instanceof Array) {
          rounds.value = response;
        }
      } catch (err) {
        //
      }
    };
    onMounted(() => {
      refresh();
    });
    const roundDeleted = () => {
      refresh();
    };
    const formatDate = (date) => moment(date).format("YYYY-MM-DD");
    const formatter = computed(() => mainFormatter);
    return {
      currencyCodeSymbolEnums,
      rounds,
      formatter,
      formatDate,
      roundDeleted,
    };
  },
});
